import { Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../enums';

import { PopupContainerProps } from './comparisonTablePopup.types';

export const PopupContainer = styled.div<PopupContainerProps>`
  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-100px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  position: fixed;
  overflow: auto;
  background: ${Color.White};
  inset: 0;
  z-index: ${AppZIndex.ComparisonTable};
  animation: ${({ $visible }: PopupContainerProps): string => $visible ? 'slideInLeft 0.6s ease-out forwards' : 'none'};
  pointer-events: ${({ $visible }: PopupContainerProps): string => $visible ? 'initial' : 'none'};
  opacity: ${({ $visible }: PopupContainerProps): string => $visible ? '1' : '0'};
`;

export const CloseButton = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
`;
